<template>
    <b-row>
        <b-col lg="12">
            <b-form-group label="Acceso actual del cliente">
              <b-table :items="accesoEfectivo" :fields="fieldsAcceso" small bordered responsive
                       :empty-text="'Este cliente no tiene motivos habilitados'" show-empty>
                <template v-slot:cell(deposit_casilda)="row">
                  <i class="fa" :class="row.item.deposit_casilda ? 'fa-check text-success' : 'fa-times text-muted'"></i>
                </template>
                <template v-slot:cell(deposit_bsas)="row">
                  <i class="fa" :class="row.item.deposit_bsas ? 'fa-check text-success' : 'fa-times text-muted'"></i>
                </template>
              </b-table>
            </b-form-group>
        </b-col>

        <b-col lg="12">
            <b-form-group label="Motivos Adicionales">
              <b-row class="mb-2">
                <b-col lg="5">
                  <b-form-input v-model="filtro.texto" placeholder="Buscar motivo..." size="sm"></b-form-input>
                </b-col>
                <b-col lg="3">
                  <b-form-select v-model="filtro.deposito" :options="arr.opcionesDeposito" size="sm"></b-form-select>
                </b-col>
                <b-col lg="4">
                  <b-form-checkbox v-model="filtro.soloIncluidos" class="mt-1">
                    Mostrar solo incluidos
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-table :items="filteredItems" :fields="fields" small bordered responsive>
                <template v-slot:cell(incluido)="row">
                  <b-form-checkbox v-model="crud.selected[row.item.id].incluido"
                                    :disabled="isSeller"
                                    @change="onToggleIncluido(row.item.id)">
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(deposit_casilda)="row">
                  <b-form-checkbox v-model="crud.selected[row.item.id].deposit_casilda"
                                    :disabled="isSeller || !crud.selected[row.item.id].incluido">
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(deposit_bsas)="row">
                  <b-form-checkbox v-model="crud.selected[row.item.id].deposit_bsas"
                                    :disabled="isSeller || !crud.selected[row.item.id].incluido">
                  </b-form-checkbox>
                </template>
              </b-table>

              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill mt-1" @click="borrarSeleccion()" v-if="!isSeller">
                <i class="icon-refresh"></i>
                Borrar Selección
              </b-button>
            </b-form-group>
        </b-col>

        <b-col lg="12">
            <b-button variant="dark" class="pull-right" size="sm" @click="save()" v-if="!isSeller">Guardar</b-button>
        </b-col>
    </b-row>
</template>
<script>
    import serviceAPI from './../services'
    import Error from '@/handler/error'
    import Session from '@/handler/session'
    import Profiles from '@/config/profiles'
    import Modules from '@/config/modules'
    import Helper from '@/handler/helper'
    import FindObject from '@/components/inc/find/findObject'

    export default {
      components: {
        FindObject,
      },
      props: [
        'customers',
        'customersID',
      ],
      data() {
        return {
          crud: {
            form: {
              customers_id: 0,
            },
            selected: {},
          },
          arr: {
            reasons: [],
            reasonsFull: [],
            opcionesDeposito: [
              {value: null, text: 'Todos los depósitos'},
              {value: 'casilda', text: 'Con Casilda habilitado'},
              {value: 'bsas', text: 'Con BsAs habilitado'},
            ],
          },
          filtro: {
            texto: '',
            deposito: null,
            soloIncluidos: false,
          },
          fields: [
            {key: 'name', label: 'Motivo'},
            {key: 'incluido', label: 'Incluido'},
            {key: 'deposit_casilda', label: 'Depósito Casilda'},
            {key: 'deposit_bsas', label: 'Depósito BsAs'},
          ],
          fieldsAcceso: [
            {key: 'name', label: 'Motivo'},
            {key: 'deposit_casilda', label: 'Depósito Casilda'},
            {key: 'deposit_bsas', label: 'Depósito BsAs'},
          ],
        }
      },
      watch: {
        customers: function (newQuestion, oldQuestion) {
          this.load()
        }
      },
      computed: {
        isSeller() {
          var seller = Helper.getSeller()
          if(seller) {
            return true
          } else {
            return false
          }
        },
        tableItems() {
          return this.arr.reasons.map(element => ({
            id: element.value,
            name: element.text,
          }))
        },
        filteredItems() {
          var texto = this.filtro.texto.trim().toLowerCase()

          return this.tableItems.filter(item => {
            var sel = this.crud.selected[item.id]
            if(!sel) return false

            if(texto && item.name.toLowerCase().indexOf(texto) === -1) return false
            if(this.filtro.soloIncluidos && !sel.incluido) return false
            if(this.filtro.deposito === 'casilda' && !sel.deposit_casilda) return false
            if(this.filtro.deposito === 'bsas' && !sel.deposit_bsas) return false

            return true
          })
        },
        accesoEfectivo() {
          var overridesPorReasonID = {}
          if(this.customers && this.customers.reasons_additional) {
            this.customers.reasons_additional.forEach(item => {
              overridesPorReasonID[item.reason_id] = item
            })
          }

          var resultado = []
          this.arr.reasonsFull.forEach(reason => {
            var override = overridesPorReasonID[reason.id]

            if(!reason.available_all_customers && !override) {
              return
            }

            var depositCasilda = !!reason.deposit_casilda
            var depositBsas = !!reason.deposit_bsas
            if(override) {
              depositCasilda = depositCasilda && !!override.deposit_casilda
              depositBsas = depositBsas && !!override.deposit_bsas
            }

            resultado.push({
              name: reason.reference + ' - ' + reason.name,
              deposit_casilda: depositCasilda,
              deposit_bsas: depositBsas,
            })
          })

          return resultado
        },
      },
      mounted() {
        this.loadReasons()
      },
      methods: {
        load() {
          this.crud.form.customers_id = this.customersID
          this.buildSelected()
        },
        loadReasons() {
          let loader = this.$loading.show();
          var result = serviceAPI.obtenerReason()

          result.then((response) => {
            var data = response.data

            this.arr.reasons = []
            this.arr.reasonsFull = []
            data.forEach(element => {
              if(element.active) {
                this.arr.reasonsFull.push(element)
              }
              if(!element.available_all_customers && element.active) {
                this.arr.reasons.push({
                   value: element.id,
                   text: element.reference + ' - ' + element.name
                })
              }
            });

            this.buildSelected()
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error))
          });
        },
        buildSelected() {
          var selected = {}

          this.arr.reasons.forEach(element => {
            selected[element.value] = {
              incluido: false,
              deposit_casilda: true,
              deposit_bsas: false,
            }
          })

          if(this.customers && this.customers.reasons_additional) {
            this.customers.reasons_additional.forEach(item => {
              if(selected[item.reason_id]) {
                selected[item.reason_id].incluido = true
                selected[item.reason_id].deposit_casilda = !!item.deposit_casilda
                selected[item.reason_id].deposit_bsas = !!item.deposit_bsas
              }
            })
          }

          this.crud.selected = selected
        },
        onToggleIncluido(reasonID) {
          if(!this.crud.selected[reasonID].incluido) {
            this.crud.selected[reasonID].deposit_casilda = false
            this.crud.selected[reasonID].deposit_bsas = false
          } else {
            this.crud.selected[reasonID].deposit_casilda = true
          }
        },
        borrarSeleccion() {
          Object.keys(this.crud.selected).forEach(reasonID => {
            this.crud.selected[reasonID].incluido = false
            this.crud.selected[reasonID].deposit_casilda = false
            this.crud.selected[reasonID].deposit_bsas = false
          })
        },
        save() {
          let loader = this.$loading.show();

          var items = []
          Object.keys(this.crud.selected).forEach(reasonID => {
            var item = this.crud.selected[reasonID]
            if(item.incluido) {
              items.push({
                reason_id: reasonID,
                deposit_casilda: item.deposit_casilda,
                deposit_bsas: item.deposit_bsas,
              })
            }
          })

          var payload = {
            customers_id: this.crud.form.customers_id,
            items: items,
          }

          serviceAPI.agregarReason(payload)
          .then((response) => {
            loader.hide()
            this.$awn.success("Datos guardados con éxito");
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error));
          })
        },
      }
    }
</script>
